import { useMediaControls } from '@vueuse/core'

export function useMediaControlSettings(
  ...args: Parameters<typeof useMediaControls>
) {
  const controls = useMediaControls(...args)

  return controls
}
